module.exports = __webpack_public_path__ + "static/img/7.8a28b61.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/zh/7.png
// module id = pUdj
// module chunks = 0